// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8cmDs","colMin":"styles_colMin__GLMzF"};